<template>
    <span class="form-row">
         <div v-if="error" class="alert alert-danger" role="alert">
            {{error}}
        </div>
        <div class="col-md-2">
            <input v-model="timeFrom" class="form-control timepicker" type="time" placeholder="Select Starting Date" />
        </div>
        <div class="col-md-2">
                    <input v-model="timeTo" class="form-control timepicker" type="time" placeholder="Select End Date" />

        </div>
        <div class="col-md-2">
            <input class="form-control number" min="0" max="100" v-model="percentage" type="number" placeholder="Traffic Percentage">
        </div>


    </span>
</template>

<script>
export default {
    name: "ServerToServerTrafficSettingPeriod",
    props: ['from', 'to', 'p', 'index'],

    data() {
        return {
            timeFrom: this.from || null,
            timeTo: this.to || null,
            percentage: this.p || null,
            error: null
        }
    },
    watch: {
        timeFrom: {
            handler() {
                this.handleTrafficSettingChange();
            },
            immediate: true
        },

        timeTo: {
            handler() {
                this.handleTrafficSettingChange();
            },
            immediate: true
        },

        percentage: {
            handler() {
               this.handleTrafficSettingChange();
            },
            immediate: true
        }
    },
    methods: {
        handleTrafficSettingChange() {
            if(!this.timeTo || !this.timeFrom ||  !this.percentage) {
                return;
            }

            const from = moment.utc(this.timeFrom, 'hh:mm');
            const to = moment.utc(this.timeTo, 'hh:mm');

            if(this.timeFrom && this.timeTo && from.isBefore(to)) {

                this.$emit('period-change', from, to, this.percentage, this.index);
                this.error = '';
            } else {
                this.error = 'From time has to be bigger than TO time';
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/traffic-settings/ServerToServerTrafficSettingPeriod.vue